module.exports = __webpack_public_path__ + "assets/img/returnBtn-65b9b019.png";